import { BrowserModule, Title } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ModalModule } from 'ngx-bootstrap/modal';
import {
  HttpInterceptorService,
  LoaderInterceptorService,
  ErrorHandlerInterceptor,
  EncryptionInterceptor,
  RetryInterceptor,
} from '@rubicon/utils';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { StoreModule, MetaReducer, META_REDUCERS } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { EffectsModule } from '@ngrx/effects';
import { AppEffects } from './+state/app.effects';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { CommonService, UtilsModule } from '@rubicon/utils';
import { environment } from '../environments/environment';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { CONSTANTS } from '../assets/ni/constant/constant';
import { LayoutModule } from '@platform-core/libraries/common/layout';
import { InactivityService,UiKitModule } from '@platform-core/libraries/core-utils/ui-kit';
import { CustomizationModule } from '@platform-core/libraries/core-utils/biz2xPro-config-engine';
import { SharedLazyModule } from '@platform-core/libraries/core-utils/shared-lazy';

import * as fromApp from './+state/app.reducer';
import { storageMetaReducer, updateRootState } from './+state/app-meta.reducer';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';

declare function require(name: string);
const ERROR_MESSAGES = require(`../assets/${environment.client_folder}/json/error-messages.json`);

export function createTranslateLoader(httpClient: HttpClient) {
  return new TranslateHttpLoader(
    httpClient,
    `./assets/i18n/`,
    '.json'
  );
}

export function getMetaReducers(
  storageService: CommonService
): MetaReducer<any> {
  return storageMetaReducer(storageService);
}

export function getCssJson() {
  return require(`../assets/${environment.client_folder}/json/css.json`);
}

export function getproductConfigJson() {
  return require(`../assets/${environment.client_folder}/json/product-config.json`);
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    ModalModule.forRoot(),
    BrowserAnimationsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
      defaultLanguage: 'en',
      isolate: false,
    }),
    AppRoutingModule,
    StoreModule.forRoot(
      { [fromApp.APP_FEATURE_KEY]: fromApp.reducer },
      { metaReducers: [updateRootState] }
    ),
    !environment.production ? StoreDevtoolsModule.instrument() : [],
    StoreRouterConnectingModule.forRoot(),
    EffectsModule.forRoot([AppEffects]),
    UtilsModule.forRoot(environment, CONSTANTS, ERROR_MESSAGES),
    LayoutModule,
    UiKitModule,
    CustomizationModule,
    CommonModule,
    SharedLazyModule.forRoot()
  ],
  providers: [
    { provide: 'APP_ROUTES', useValue: CONSTANTS.APP_ROUTES },
    { provide: 'APP_STEP', useValue: CONSTANTS.APP_STEP },
    { provide: 'environment', useValue: environment },
    {
      provide: 'constants', useValue: CONSTANTS
    },
    { provide: 'CONSTANTS', useValue: CONSTANTS },
    { provide: 'cssList', useFactory: getCssJson },
    { provide: 'productConfig', useFactory: getproductConfigJson },
    {
      provide: META_REDUCERS,
      multi: true,
      deps: [CommonService],
      useFactory: getMetaReducers,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorService,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptorService,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorHandlerInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: EncryptionInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RetryInterceptor,
      multi: true,
    },
    InactivityService,
    Title,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
